// material-ui
import { alpha, Theme } from "@mui/material/styles";

// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          "& .MuiBackdrop-root": {
            background:
              theme.palette.mode === "dark"
                ? `linear-gradient(180deg, ${alpha("#020617", 0.84)} 0%, ${alpha(
                    theme.palette.common.black,
                    0.74,
                  )} 100%)`
                : `linear-gradient(180deg, ${alpha("#0f172a", 0.28)} 0%, ${alpha(
                    "#0f172a",
                    0.42,
                  )} 100%)`,
            backdropFilter: "blur(10px) saturate(135%)",
          },
        },
        paper: {
          position: "relative",
          overflow: "hidden",
          borderRadius: 24,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
          backgroundImage: `linear-gradient(180deg, ${alpha(
            theme.palette.background.paper,
            0.98,
          )} 0%, ${theme.palette.background.paper} 58%, ${alpha(
            theme.palette.grey[50],
            0.92,
          )} 100%)`,
          boxShadow: `0 28px 80px ${alpha(theme.palette.grey[900], 0.22)}, 0 10px 28px ${alpha(
            theme.palette.primary.main,
            0.14,
          )}`,
          backdropFilter: "blur(18px) saturate(140%)",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            bottom: "auto",
            height: 4,
            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.info.main} 52%, ${theme.palette.success.main} 100%)`,
          },
        },
        paperWidthXs: {
          maxWidth: 480,
        },
        paperScrollPaper: {
          width: "calc(100% - 32px)",
          maxHeight: "calc(100% - 32px)",
        },
        container: {
          padding: theme.spacing(2),
        },
      },
    },
  };
}
